import makeRequest from '@jg/http-client';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { Auth } from '@jg/auth';
import { httpActions } from '..';
import { REQUEST, ERROR_MESSAGES } from '../../consts';
import config from '../../config';
import {
  redirectByResponseStatus,
  mapGDPRConsents,
  generateAuthHeaders,
} from '../../utils';
import { IAppState, IGDPRConsent } from '../../types/state.d';
import {
  getGDPRConsents,
  getTeamCharityId,
  getTeamGuid,
} from '../../selectors/apiSelectors';
import logInfo from './logInfo';
import { getLocks } from '../../selectors/locksSelectors';

const updateGDPRConsents = (frpId: number, gdprOptIn: boolean) => async (
  dispatch: ThunkDispatch<IAppState, void, Action>,
  getState: () => IAppState,
  auth: Auth,
) => {
  await auth.refreshAccessTokenIfExpired();
  const accessToken = auth.getAccessToken();

  if (typeof accessToken === 'undefined') {
    return;
  }

  const resourceName = REQUEST.UPDATE_GDPR_CONSENTS;
  const teamGuid = getTeamGuid(getState());
  const GDPRConsents = getGDPRConsents(getState());
  const locks = getLocks(getState());
  try {
    const state = getState();
    const charityId = getTeamCharityId(state);
    const consents = getGDPRConsents(state) as IGDPRConsent[];
    dispatch(httpActions.httpRequestMade(resourceName));
    const loggingData = {
      frpId,
      teamGuid,
      userGuid: accessToken.guid,
      locks,
      GDPRConsents,
      gdprOptIn,
    };
    const response = await makeRequest(
      `${config.preferenceServiceAPI}/users/${accessToken.guid}/consents`,
      {
        method: 'PUT',
        body: JSON.stringify({
          CollectionLocationId: 2,
          TransactionTypeId: 2,
          isConsentRequired: true,
          TransactionId: frpId,
          Consents: mapGDPRConsents(consents, gdprOptIn, charityId),
        }),
        extraHeaders: {
          ...generateAuthHeaders(auth),
        },
      },
    );
    if (response && !response.ok) {
      dispatch(
        logInfo({
          tags: ['api_failure'],
          message: ERROR_MESSAGES.UPDATE_GDPR_CONSENTS,
          method: 'PUT',
          body: loggingData,
          res: response.bodyUsed ? null : await response.json(),
        }),
      );
      redirectByResponseStatus(response.status);
      throw new Error(ERROR_MESSAGES.UPDATE_GDPR_CONSENTS);
    }
    dispatch(httpActions.httpRequestSuccess(resourceName));
    dispatch(
      logInfo({
        tags: ['api_success'],
        message: 'success updating gdpr consents',
        method: 'PUT',
        body: loggingData,
        res: response.bodyUsed ? null : await response.json(),
      }),
    );
  } catch (error) {
    dispatch(httpActions.httpRequestError(resourceName, error));
    redirectByResponseStatus(error.status);
  }
};

export default updateGDPRConsents;
